export const transitionDuration = '0.3s'
export const fontWeightBold = 600
